import SwitchSite from './components/SwitchSite';

const api = {
  getSwitchSiteComponent: () => SwitchSite,
};

export default api;

export type ApiType = typeof api;
